import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { auth } from "../lib/auth";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";

export default function AuthCallbackPage() {
  const navigate = useNavigate();
  const [ready, setReady] = useState(false);
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    auth.completeCallback().then(() => setReady(true)).catch((reason) => setError(reason.message));
  }, []);

  async function submit(event) {
    event.preventDefault();
    if (password.length < 12) return setError("Use at least 12 characters.");
    if (password !== confirmPassword) return setError("Passwords do not match.");
    setSaving(true);
    setError("");
    try {
      await auth.setPassword(password);
      navigate("/app", { replace: true });
    } catch (reason) {
      setError(reason.message || "Unable to set your password.");
    } finally {
      setSaving(false);
    }
  }

  return <main className="min-h-screen grid place-items-center bg-slate-950 p-5 text-white">
    <form onSubmit={submit} className="w-full max-w-md space-y-4 rounded-2xl bg-white p-6 text-slate-950 shadow-2xl">
      <h1 className="text-2xl font-black">Finish securing your account</h1>
      <p className="text-sm text-slate-600">Set the password for your OmniMark account. It is never stored by OmniMark, and this secure link expires automatically.</p>
      {error && <p role="alert" className="rounded-md bg-red-50 p-3 text-sm text-red-800">{error}</p>}
      {ready && <>
        <Input type="password" autoComplete="new-password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Create a password (12+ characters)" />
        <Input type="password" autoComplete="new-password" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} placeholder="Confirm password" />
        <Button className="w-full" disabled={saving}>{saving ? "Securing account…" : "Set password and continue"}</Button>
      </>}
    </form>
  </main>;
}
